import { inject, InjectionToken, Provider } from '@angular/core';
import { submissionAdminSignalStore } from './signal-stores/submission-admin.signal-store';
import { SubmissionAdminSignalState } from '../types/submission-admin.types';

/**
 * Injection token for the submission admin signal store
 */
export const SUBMISSION_ADMIN_TOKEN =
  new InjectionToken<SubmissionAdminSignalState>(
    'Submission Admin Signal Store',
  );

/**
 * Provider for the submission admin signal store
 */
export const SUBMISSION_ADMIN_PROVIDER: Provider = {
  provide: SUBMISSION_ADMIN_TOKEN,
  useClass: submissionAdminSignalStore,
};

/**
 * Submission Admin Tokenizer - provides the submission admin signal store instance
 */
export function submissionAdminTokenizer() {
  return inject(SUBMISSION_ADMIN_TOKEN);
}

/**
 * Type definition for the submission admin tokenizer
 */
export type SubmissionAdminTokenizer = ReturnType<
  typeof submissionAdminTokenizer
>;
